export interface IEventUrgencyClassListItem {
    id: string;
    companyId: string;
    code: string;
    comment: string;
    sortOrder: number;
    color: string;
    defaultUrgencyClass: boolean;
    activeState: number;
}

export class EventUrgencyClassListItem implements IEventUrgencyClassListItem {
    id: string;
    companyId: string;
    code: string;
    comment: string;
    sortOrder: number;
    color: string;
    defaultUrgencyClass: boolean;
    activeState: number;

    constructor();
    constructor(obj: IEventUrgencyClassListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.companyId = obj && obj.companyId || "";
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
        this.sortOrder = obj && obj.sortOrder || 0;
        this.color = obj && obj.color || "";
        this.defaultUrgencyClass = obj && obj.defaultUrgencyClass || false;
        this.activeState = obj && obj.activeState || 0;
    }
}